import { TemplateRow } from '../../../app/components/fields-template/field-template';
import type { basePheFields, basePlanningFields } from '../entitytypes';

type BaseET = {
    fields_planning: typeof basePlanningFields;
    fields_phe: typeof basePheFields;
    fields_planning_data?: Record<string, unknown> | null;
    fields_phe_data?: Record<string, unknown> | null;
};

export const REPETITION_ROWS: TemplateRow<BaseET>[] = [
    {
        type: 'row',
        children: [
            { type: 'field', fieldKey: 'repetition', fieldGroup: 'planning', classes: 'col-8 col-md-auto' },
            { type: 'field', fieldKey: 'repetitionEndDate', fieldGroup: 'planning', classes: 'col' },
            { type: 'field', fieldKey: 'nrOfRepetitions', fieldGroup: 'planning', classes: 'col' },
            { type: 'field', fieldKey: 'interval_week', fieldGroup: 'planning', classes: 'col-8 col-md' },
            { type: 'field', fieldKey: 'weekdays', fieldGroup: 'planning', classes: 'col-md col-24' },
        ],
    },
    {
        type: 'row',
        children: [{ type: 'field', fieldKey: 'datesLabel', fieldGroup: 'planning', classes: 'col-24' }],
    },
];
